import { array, object } from "superstruct";

import GiftRegistryItemSchema from "./GiftRegistryItemSchema";

const GiftRegistryItemsResponseSchema = object({
    giftRegistryItems: array(GiftRegistryItemSchema),
});

export default GiftRegistryItemsResponseSchema;
